import * as React from "react";
import { forwardRef } from "react";
const SvgResizeDownRight2 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2 20H20V2", stroke: "#33363F", strokeWidth: 3 }), /* @__PURE__ */ React.createElement("path", { d: "M6 15H15V6", stroke: "#33363F", strokeWidth: 3 }));
const ForwardRef = forwardRef(SvgResizeDownRight2);
export { ForwardRef as ReactComponent };
